'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { Subtitle, Title, HeroList } from '../../components';
import { Button, Container } from '@/components';
import { useVisible } from '@/hooks';

import { ConsolidationLoansCards } from './ConsolidationLoansCards';
import styles from './consolidationLoansHero.module.scss';

type Props = {
  data: Simplify<Content.HeroSliceConsolidationLoansPrimary>;
};

export const ConsolidationLoansHero: FC<Props> = ({ data }) => {
  const [isVisible, id] = useVisible();

  return (
    <Container styles={styles.container}>
      <div className={styles.hero} id={id}>
        <article className={styles.text_content}>
          <Title
            text={data.title}
            styles={styles.title}
            isVisible={isVisible}
          />
          <Subtitle
            subtitle={data.subtitle}
            styles={styles.subtitle}
            isVisible={isVisible}
          />
          <HeroList list={data.advantages} isVisible={isVisible} />
          <div
            className={`${styles.button_wrapper} ${isVisible ? styles.isVisible : ''}`}
          >
            <Button
              variation="primary"
              text={data.button_text}
              link={data.button_link}
              styles={styles.button}
              isArrow
            />
          </div>
        </article>
        <ConsolidationLoansCards data={data} isVisible={isVisible} />
      </div>
    </Container>
  );
};
